module.exports = __webpack_public_path__ + "static/media/IoT.12065094.svg";